import React, {Component, Fragment} from 'react';
import Modal from 'react-bootstrap-modal';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {deleteAccount} from 'backend-helpers/member';
import {logout} from 'reducers/currentUser';

import 'sass/modals/modalConfirmDelete.scss';

import {dt, t} from 'l10n';

class ModalConfirmDelete extends Component {
    state = {email: '', phone: ''};

    requestDelete = () => {
        const {logout} = this.props;
        deleteAccount()
            .then(res => {
                const {email, phone} = res.data;
                this.setState({email, phone});
                logout();
            })
    };

    render() {
        const {email, phone} = this.state;
        const {show, closeFn, currentUser} = this.props;
        return (
            <Modal className="modalConfirmDelete" show={show} onHide={closeFn}>
                <Modal.Body>
                    <div className="close" onClick={closeFn}/>
                    {email && phone && <p className="text">{dt('delete', 'Your request is received. You will get a confirmation by email %1 and by phone %2 when the administrator deletes your account.', email, phone)}</p>}
                    {email && !phone && <p className="text">{dt('delete', 'Your request is received. You will get a confirmation by email %1 when the administrator deletes your account.', email)}</p>}
                    {!email && !phone &&
                        <Fragment>
                            <div className="banner">{t('Delete my account')}</div>
                            <p className="text" dangerouslySetInnerHTML={{__html: dt('delete', 'You can request deletion of your account <strong class=\'nickname\'>%1</strong> by clicking the button below.', currentUser.nick)}} />
                            <p className="text">{dt('delete' ,'All data in this account will be deleted as soon as possible by the administrator (subscription, photos, videos, email addresses ...)')}</p>
                            <p className="text">{dt('delete', 'WARNING: Your request will not be cancelable, it will not be possible to access your account, your data and your subscription after its removal.')}</p>
                        </Fragment>
                    }
                    <div className="form">
                        <div className="form-group">
                            <div className={`buttons ${(email || phone) ? 'center' : ''}`}>
                                {!email && !phone && <button onClick={this.requestDelete} className="delete">{t('Delete my account')}</button>}
                                <button className="close" onClick={closeFn}>{t('Close')}</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

ModalConfirmDelete.propTypes = {
    show: PropTypes.bool.isRequired,
    logout: PropTypes.func.isRequired,
    closeFn: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
   currentUser: state.currentUser
});

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalConfirmDelete);


// WEBPACK FOOTER //
// ./src/components/modals/ModalConfirmDelete.js